var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".back_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "back_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "back_svg__cls-1",
    d: "M67.53 52.6H32.81a4.6 4.6 0 010-9.2h34.72a4.6 4.6 0 010 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "back_svg__cls-1",
    d: "M45.83 70a4.57 4.57 0 01-3.25-1.35l-17.36-17.4a4.61 4.61 0 010-6.5l17.36-17.38a4.59 4.59 0 116.5 6.49L35 48l14.08 14.13A4.6 4.6 0 0145.83 70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "back_svg__cls-1",
    d: "M48 0A48 48 0 110 48 48.05 48.05 0 0148 0zm0 94A46 46 0 102 48a46.06 46.06 0 0046 46z"
  })))));
}

export default SvgBack;